import { z } from 'zod';
import { BlockSchema } from './Block.types';

import { TestimonialBlockConfigSchema } from './blockConfig/Types';

export const TestimonialBlockSchema = BlockSchema.extend({
  blockConfig: TestimonialBlockConfigSchema,
});

export type TestimonialBlock = z.infer<typeof TestimonialBlockSchema>;
